// document.querySelector('[action="/cart/add"]')

// on document ready
document.addEventListener("DOMContentLoaded", function() {
  document.addEventListener("mulberry-shopify:loaded", async () => {
    if (window.location.href.indexOf("/products/") !== -1) {
      initMulberry();
    }
  });
});

document.addEventListener("mulberry-shopify-offers:loaded", function() {
  console.log('Mulberry offers are loaded!')
});


// get offers
async function getOffers() {
  const productData = await window.mulberryShop.getProductData(
    window.mulberryShop.getProductUrl()
  );
  product = productData.product;
  window.mulberryShop.selectedVariantId = window.selectedVariantId;
  window.selectedVariant = product.variants.find(
    (i) => i.id == window.mulberryShop.selectedVariantId
  );
  if (!window.selectedVariant) {
    window.selectedVariant = product.variants[0];
  }
  if (
    window.selectedVariant &&
    window.selectedVariant.id &&
    window.selectedVariant.price
  ) {
    return window.mulberry.core.getWarrantyOffer({
      detail: {...product, id: window.selectedVariant.id},
      title: product.title,
      id: window.selectedVariant.id,
      price: window.selectedVariant.price,
    });
  }
}
async function initMulberry() {

  const mulberryOffersEv = new CustomEvent("mulberry-shopify-offers:loaded");

  window.offers = await getOffers();

  await window.mulberry.inline.init({
    offers: window.offers,
    layout: {
      logo: false,
      faq: false
  	},
    settings: window.mulberry.core.settings,
    selector: "#mulberry-container",
    onWarrantyToggle: async (warranty) => {
      if (warranty.isSelected) {
        window.selectedWarranty = warranty;
        window.productForWarranty = product;
      } else {
        window.selectedWarranty = null;
        window.productForWarranty = null;
      }
    },
  });

  document.dispatchEvent(new Event("mulberry-shopify-offers:loaded"));

  mulberry.faq.init({
    coverage: mulberry.core.offers[0],
    settings: mulberry.core.settings
  })
  document.querySelector("#whats-covered-faq").removeAttribute("style")
  document.querySelector("#whats-covered-faq")?.addEventListener("click",function(){
    mulberry.faq.open();
  });
  window.mulberryPDPModal = window.mulberry.modal.init({
    offers: window.offers,
    settings:window.mulberry.core.settings,
    onWarrantySelect: async (warranty) => {
      console.log("Warranty selected", warranty);
      window.productForWarranty = product;
      const result = await window.mulberryShop.getWarrantyVariant(
        warranty
      );
      await window.mulberryShop.addWarrantyToCart(
        result.shopify_variant_id,
        {...product, variantId: `${window.selectedVariant.id}`, quantity: 1},
        warranty
      );
      window.selectedWarranty = null;
      const formElement = window.originalBundleForm || document.querySelector('product-form');
      formElement.warranty =
      {
        result: result,
        product: window.productForWarranty,
        warranty: warranty,
      }
      window.mulberry.modal.close();
      formElement.directCheckout()
    },
    onWarrantyDecline: () => {
      mulberry.modal.close()
      const formElement = window.originalBundleForm || document.querySelector('product-form');
      formElement.directCheckout()
    }
  })
}

window.addWarrantyToCart = async (e) => {
  console.log("open warranty modal",JSON.stringify(window.selectedWarranty),window.selectedWarranty != null);

  if (
    window.selectedWarranty &&
    window.selectedWarranty != null
  ) {
    try {
      const result = await window.mulberryShop.getWarrantyVariant(
        window.selectedWarranty.offer
      );
      await window.mulberryShop.addWarrantyToCart(
        result.shopify_variant_id,
        {...product, variantId: `${window.selectedVariant.id}`, quantity: 1},
        window.selectedWarranty.offer
      );
      window.selectedWarranty = null;
      window.mulberry.inline.deselectOffer()
      return {
        result,
        product: window.productForWarranty,
        warranty: window.selectedWarranty,
      }
    } catch (error) {
      return {
        result: null,
        product: window.productForWarranty,
        warranty: window.selectedWarranty,
      }
    }
  } else {
    window.mulberry.inline.deselectOffer();
    console.log("open warranty modal");
    window.mulberry.modal.open()
    return null;
  }
}